import { transactionLabel } from '../utils/transactionLabels';
import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Chip, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { GiftAmount, GiftSentChip } from './GiftPresentation';
import { cents, money } from '../utils/transactionSelection';

function ActivityCard({ item, accounts, categories, editable, onOpenEvent, onEdit, onDelete, onReceipt }) {
  const [menu, setMenu] = useState(null);
  const { event, transaction: row } = item;
  const kind = event?.transaction_type || row.transaction_nature || (Number(row.amount) < 0 ? 'expense' : 'income');
  const gift = event ? item.giftCount === event.row_count : row.user_label === 'gift';
  const account = event?.account_name || accounts.find(a => a.id === row.account_id)?.name || 'Unknown account';
  const category = categories.find(c => c.id === row.category_id)?.name || 'No category';
  const action = kind === 'income' ? 'Correct deposit' : 'Adjust purchase split';
  const receiptId = event?.receipt_intake_id || row.receipt_intake_id;
  return <Card sx={{ mb: 1.5 }}><CardContent>
    <Stack spacing={1.2}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ overflowWrap: 'anywhere', minWidth: 0 }}>{item.label}</Typography>
        {gift ? <GiftAmount amount={item.amount} /> : <Typography fontWeight="bold" color={kind === 'transfer' ? 'info.main' : Number(item.amount) < 0 ? 'error.main' : 'success.main'} sx={{ flexShrink: 0 }}>
          {money(cents(item.amount))}
        </Typography>}
        {!event && <IconButton size="small" aria-label={`Actions for ${item.label}`} onClick={e => setMenu(e.currentTarget)}><MoreVertIcon /></IconButton>}
      </Box>
      <Typography variant="body2" color="text.secondary">{item.transaction_date} · {account}</Typography>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {gift ? <GiftSentChip /> : <Chip size="small" label={event ? kind : transactionLabel(row)} variant="outlined" />}
        {event && item.giftCount > 0 && item.giftCount < event.row_count && <Chip size="small" label="Includes gifts" variant="outlined" />}
        <Chip size="small" label={event ? `${event.row_count} allocations` : category} />
        {event?.historical && <Chip size="small" variant="outlined" label={event.ambiguous ? 'Grouping needs review' : 'Historical split'} />}
      </Stack>
      {event && <>
        <Typography variant="body2" color="text.secondary">{event.source_type === 'receipt' ? 'Receipt purchase' : event.source_type === 'daily_tally' ? 'Daily Tally purchase' : event.template_name || 'Recorded split'}</Typography>
        {item.matchedCount < event.row_count && <Typography variant="body2">
          {item.matchedCount} of {event.row_count} allocations match this view: {money(item.matchedAmount)}. Card total is the whole event.
        </Typography>}
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {editable && event.can_correct && <Button size="small" onClick={() => onOpenEvent(event.anchor_transaction_id, true)}>{action}</Button>}
          <Button size="small" onClick={() => onOpenEvent(event.anchor_transaction_id, false)}>View breakdown</Button>
        </Stack>
      </>}
      {receiptId && <Button size="small" sx={{ alignSelf: 'flex-start' }} onClick={() => onReceipt(receiptId)}>View original receipt</Button>}
    </Stack>
    <Menu anchorEl={menu} open={!!menu} onClose={() => setMenu(null)}>
      <MenuItem onClick={() => { setMenu(null); onEdit(row); }}>Edit transaction</MenuItem>
      {!row.workflow_linked && <MenuItem onClick={() => { setMenu(null); onDelete(row.id); }}>Delete transaction</MenuItem>}
    </Menu>
  </CardContent></Card>;
}

export default function SplitActivity({ items, ...props }) {
  return <Box aria-label="Transaction activity">{items.map(item => <ActivityCard key={item.key} item={item} {...props} />)}</Box>;
}
